import { isEmpty, map } from "lodash";
import Grid from "@mui/system/Unstable_Grid";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { useQuery } from "react-query";
import { listFlyers } from "../../../../services/arts";
import { Arts, Flyer } from "../../../../types/arts";
import { ArtImage } from "../../../../components/ArtImage";

type ImagesProps = {
  art: Arts;
  onSelect: (data: Flyer) => void;
};

export function Images({ art, onSelect }: ImagesProps) {
  const flyers = useQuery(
    ["flyers", art?.id_tabloide_digital],
    () => listFlyers(Number(art?.id_tabloide_digital)),
    { enabled: Boolean(art) }
  );

  return (
    <Grid container spacing={2}>
      {flyers.isLoading ? (
        <Grid xs={12} justifyContent="center" sx={{ display: "flex" }}>
          <CircularProgress />
        </Grid>
      ) : isEmpty(flyers.data) ? (
        <Grid xs={12} justifyContent="center" sx={{ display: "flex" }}>
          <Typography color="GrayText">Lista de artes vazia.</Typography>
        </Grid>
      ) : (
        map(flyers.data, (flyer, index) => (
          <Grid xs={2} key={index}>
            <ArtImage
              onClick={() => onSelect(flyer)}
              image={flyer.image_url}
              name={flyer.name}
            />
          </Grid>
        ))
      )}
    </Grid>
  );
}
